import { Users } from "lucide-react";

const level = (count, max) => {
  if (!max) return { bar: "bg-emerald-500", text: "text-emerald-300", note: "Posti illimitati", key: "ok" };
  const left = max - count;
  if (left <= 0) return { bar: "bg-red-500", text: "text-red-300", note: "GARA AL COMPLETO", key: "full" };
  if (left <= 5) return { bar: "bg-amber-400", text: "text-amber-300", note: `Ultimi ${left} ${left === 1 ? "posto" : "posti"}`, key: "low" };
  return { bar: "bg-emerald-500", text: "text-emerald-300", note: `${left} posti liberi`, key: "ok" };
};

export function AdmittedCounter({ count, max, variant = "bar" }) {
  if (count == null) return null;
  const l = level(count, max);
  const pct = max ? Math.min(100, Math.round((count / max) * 100)) : 100;
  const onResult = variant === "result";
  return (
    <div data-testid={`admitted-counter-${variant}`} data-level={l.key}
      className={onResult ? "mt-4 rounded-2xl bg-black/20 p-4" : "rounded-2xl border border-slate-800 bg-slate-900/95 p-3 shadow-lg backdrop-blur"}>
      <div className="flex items-end justify-between gap-3">
        <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-white/70"><Users className="h-4 w-4" />Ammessi</div>
        <div className={`text-xs font-bold uppercase tracking-wide ${onResult ? "text-white" : l.text}`} data-testid={`admitted-counter-${variant}-note`}>{l.note}</div>
      </div>
      <div className="mt-1 font-display font-black leading-none tracking-tight" data-testid={`admitted-counter-${variant}-value`}>
        <span className="text-5xl tabular-nums">{count}</span>
        {max > 0 && <span className="text-2xl text-white/60"> / {max}</span>}
      </div>
      <div className="mt-2 h-2 overflow-hidden rounded-full bg-white/15">
        <div className={`h-full rounded-full transition-[width] duration-500 ${l.bar}`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
